// extracted by mini-css-extract-plugin
export var attribution = "Testimonial-module--attribution--15667";
export var content = "Testimonial-module--content--737db";
export var credentials = "Testimonial-module--credentials--8c806";
export var cta = "Testimonial-module--cta--b59c5";
export var fadeIn = "Testimonial-module--fadeIn--675db";
export var gradient = "Testimonial-module--gradient--9b541";
export var headshot = "Testimonial-module--headshot--82013";
export var image = "Testimonial-module--image--6576a";
export var inView = "Testimonial-module--in-view--61725";
export var quote = "Testimonial-module--quote--16771";
export var section = "Testimonial-module--section--3bd17";